import { Icon, Text } from "@blockdaemon-internal/design-system";
import { Trans } from "@lingui/react/macro";
import { Box, Container, Stack, Title, useMantineColorScheme } from "@mantine/core";
import { ArrowLeft } from "lucide-react";
import badgePurple from "../../assets/blockdeamon-badge-purple.svg";
import badgeWhite from "../../assets/blockdeamon-badge-white.svg";
import { getMutedTextColor } from "../utils/theme-colors";
import { NavigationButton } from "./navigation-button";

interface NotFoundPageProps {
  fullHeight?: boolean;
}

export function NotFoundPage({ fullHeight = false }: NotFoundPageProps) {
  const { colorScheme } = useMantineColorScheme();

  return (
    <Container
      h={fullHeight ? "100vh" : undefined}
      display="flex"
      style={{ alignItems: "center", justifyContent: "center" }}
      my={fullHeight ? "undefined" : "5rem"}
    >
      <Stack align="center" gap="lg">
        <Stack align="center" gap="xs" mb="lg">
          {fullHeight &&
            (colorScheme === "dark" ? (
              <Box component="img" src={badgeWhite} alt="Blockdaemon Badge White" w={50} />
            ) : (
              <Box component="img" src={badgePurple} alt="Blockdaemon Badge Purple" w={50} />
            ))}

          <Title order={1}>
            <Trans>Page Not Found</Trans>
          </Title>
          <Text
            size="lg"
            style={{
              color: getMutedTextColor(),
            }}
          >
            <Trans>The page you're looking for doesn't exist.</Trans>
          </Text>
        </Stack>
        <NavigationButton to="/">
          <Box component={Icon} icon={ArrowLeft} mr="0.5rem" />
          <Trans>Go Back</Trans>
        </NavigationButton>
      </Stack>
    </Container>
  );
}
